export default __webpack_public_path__ + "static/media/picture_scroll4.82d5a3bf.jpg";